import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { IntlProvider } from 'react-intl';
import DealWizard from '../../../components/Succession/Deals/DealWizard';
import SuccessionThemeProvider from '../../../components/Succession/SuccessionThemeProvider';
import { AgentProvider } from '../../../components/Succession/AgentSystem/AgentProvider';
import AgentWidgetRenderer from '../../../components/Succession/AgentSystem/AgentWidgetRenderer';
import client from '../../../lib/apolloClient';
import getMessages from '../../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../../hooks/useCurrency';

const GET_DEAL_WIZARD_DATA = gql`
  query GetDealWizardData {
    getCurrentUser {
      id
      name
      email
      motivation
      features
      company {
        id
        stylesheet_name
        business_type
        deal_room_branded_name
        deal_room_branded_name_fr
        hide_list_price_in_deal_room_wizard_succession
        hide_list_price_in_deal_room_wizard_continuity
        hide_list_price_in_deal_room_wizard_sale
        teaser_hide_business_overview_question
        teaser_hide_assets_question
        has_affiliation
        allow_user_affiliations
        deal_room_reminder_seller_about_valuation
        valuation_url
        country
        features
        # Marketplace colors for theming
        primary_color
        secondary_color
        accent_color
        neutral_color
        background_color
      }
      match_preference {
        id
        affiliation_weight
        product_mix_weight
        part_of_team_weight
        distance_weight
        length_of_service_weight
        length_of_service_min
        length_of_service_max
        aum_weight
        aum_min
        aum_max
        avg_age_of_client_weight
        avg_age_of_client_min
        avg_age_of_client_max
        proximity_max
        affiliate_network_weight
      }
      inventory_user {
          id
          deals {
            id
            deal_name
            deal_type
            deal_state
            headline
            sub_headline
            summary_of_business
            ideal_candidate
            list_price
            invitation_deadline
            growth_opportunities
            assets_included
            intangible_assets_included
            customer_demographics_comments
            products_and_services_comments
            question_1
            question_2
            question_3
            question_4
            question_5
          }
          deal_draft_data
          deal_draft_step
        }
    }
  }
`;

const DealWizardContainer = () => {
  const locale = window.locale || 'en';
  return (
    <CurrencyProvider currency={window.currency || 'USD'}>
    <IntlProvider locale={locale} messages={getMessages(locale)}>
    <Query query={GET_DEAL_WIZARD_DATA} client={client}>
      {({ loading, error, data }) => {
        if (loading) return <div className="flex justify-center items-center min-h-screen bg-succession-bg-secondary">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-succession-primary"></div>
        </div>;

        if (error) return <div className="flex justify-center items-center min-h-screen bg-succession-bg-secondary">
          <div className="bg-succession-error-bg border border-succession-error-border rounded-md p-4">
            <div className="text-succession-error-text">Error loading wizard data: {error.message}</div>
          </div>
        </div>;

        return (
          <SuccessionThemeProvider company={data?.getCurrentUser?.company || {}}>
            <AgentProvider>
              <DealWizard data={data} />
              <AgentWidgetRenderer />
            </AgentProvider>
          </SuccessionThemeProvider>
        );
      }}
    </Query>
    </IntlProvider>
    </CurrencyProvider>
  );
};

export default DealWizardContainer; 